<div class="row mt-4">
  <div class="col-12">
    <h1 class="centrar_contenido">Configuración exclusión <br> de asignaturas</h1>
  </div>
</div>

<p class="text-muted">Seleccione el tipo de proceso que desea excluir</p>
<div class="row align-items-baseline">
  <div class="col">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': currentTab === 'individual'}" id="tab-individual" data-toggle="tab" href="#tab-individual" role="tab" aria-controls="tab-individual" aria-selected="true" (click)="changeTab('individual')">Individual</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': currentTab === 'masivo'}" id="tab-masivo" data-toggle="tab" href="#tab-masivo" role="tab" aria-controls="tab-masivo" aria-selected="false" (click)="changeTab('masivo')">Masivo</a>
      </li>
    </ul>
  </div>
</div>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Criterios de búsqueda</h6>
</div>

<!-- Alertas exclusion masiva -->
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeErrorExclusionMasiva !== ''">
  <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ mensajeErrorExclusionMasiva }}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-danger">&times;</span>
  </button>
</div>
<div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExitoExclusionMasiva !== ''">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{ mensajeExitoExclusionMasiva }}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-success">&times;</span>
  </button>
</div>
<!-- Fin alertas exclusion masiva -->

<form [formGroup]="parametrosForm">
<div class="row mt-5 mb-4 align-items-end">
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
        <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" formControlName="anyo"
        [(ngModel)]="filtrosExclusion.anyo" (ngModelChange)="resetearValidacion();getListaPeriodos()"
        [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }" required>
            <option [value]="0" selected hidden>Seleccionar</option>
            <option [value]="anyo" *ngFor="let anyo of listaAnyos">{{anyo}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
        <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtrosExclusion.periodoId"   formControlName="periodo"
        (ngModelChange)="resetearValidacion();getListaSedes(); getListaAsignatura(filtrosExclusion.sedeId,filtrosExclusion.tipoAsignaturaId)" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }" required>
            <option [value]="0" selected hidden>Seleccionar</option>
            <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodos">{{periodo.periodoDescripcion}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
        <label *ngIf="!rolDaraCentral" class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" formControlName="sede" [(ngModel)]="filtrosExclusion.sedeId" [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
          <option [value] = "0" selected>Seleccionar</option>
          <option [value]="sede.sedeId" *ngFor="let sede of listaSedes">{{sede.descripcion}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['sede']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErrores['sede']">Campo requerido</div>
        </div>
    </div>
    <div class="col-1 centrar_iconos_botones" [hidden]="currentTab !== 'individual'">
        <button type="button" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR" (click)="buscarExclusionAsignaturas()"><i class="bi bi-search"></i></button>
    </div>
    <div class="col-1 centrar_iconos_botones">
        <button type="button" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="LIMPIAR" alt="LIMPIAR" (click)="limpiarFiltros()"><i class="bi bi-x"></i></button>
    </div>
</div>
<div class="row mt-3">
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Categoría asignatura</label>
        <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" formControlName="tipoAsignatura" [(ngModel)]="filtrosExclusion.tipoAsignaturaId" (ngModelChange)="resetearValidacion();getListaAsignatura(filtrosExclusion.sedeId,filtrosExclusion.tipoAsignaturaId)" [ngClass]="{ 'is-invalid': submitted && tieneErrores['tipoAsignatura'] }" required>
            <option value = "0" selected>Seleccionar</option>
            <option [value]="tipoAsignatura.idCategoria" *ngFor="let tipoAsignatura of listaTipoAsignatura">{{tipoAsignatura.descCategoria}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['tipoAsignatura']" class="invalid-feedback">
            <div *ngIf="tieneErrores['tipoAsignatura']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
            <label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
            <div class="input-group mb-0">
                <mat-autocomplete #autoAsignatura="matAutocomplete" [displayWith]="displayFnAsignatura">
                    <mat-option *ngFor="let asignatura of filteredAsignatura | async" [value]="asignatura">
                        {{asignatura?.codigo}}
                    </mat-option>
                </mat-autocomplete>
                <input type="text" class="form-control select_criterios" placeholder="Sigla asignatura"
                    aria-describedby="basic-addon2" [formControl]="searchAsignaturaForm" formControlName="asignatura" [matAutocomplete]="autoAsignatura" [ngClass]="{ 'is-invalid': submitted && tieneErrores['asignatura'] }" required (ngModelChange)="resetearValidacion()">
                    <div *ngIf="submitted && tieneErrores['asignatura']" class="invalid-feedback">
                        <div *ngIf="tieneErrores['asignatura']">Campo requerido</div>
                    </div>
            </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
        <div class="input-group mb-0">
            <mat-autocomplete #autoSeccion="matAutocomplete" [displayWith]="displayFnSeccion">
                <mat-option *ngFor="let seccion of filteredSeccion | async" [value]="seccion">
                  {{seccion?.codigo}}
                </mat-option>
            </mat-autocomplete>
            <input type="text" class="form-control select_criterios" placeholder="Sección" aria-describedby="basic-addon2" [formControl]="searchSeccionForm" formControlName="seccion" [matAutocomplete]="autoSeccion">
        </div>
    </div>
    
</div>
</form>
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="error">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ error }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
</div>
<div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExito">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
</div>
<!-- FIN CRITERIO DE BUSQUEDA -->

<div class="contenedor-exclusion-individual" [hidden]="currentTab !== 'individual'">
  <div class="row mt-4">
      <div class="col-3 ml-4 mt-4 d-flex align-items-center justify-content-center py-1 fondo_gris">
          <p class="mb-0">Cantidad de registros: <strong>{{listaDatos.length}}</strong> </p>
      </div>
      <div class="col" *ngIf="listaDatos.length > 0">
          <div class="d-flex ml-4 mt-4 justify-content-end">
              <p class="mr-3 mb-0">Excluir todas:</p>
  
              <td>
                  <button hidden id="btn-modal" data-toggle="modal" data-target="#modalConfirmar"></button>
                  <label class="switch" (click)="modalConfirmacion()">
                      <input type="checkbox" [checked]="excluirTodos" disabled>
                          <span class="slider round"></span>
                  </label>
                  <span class="pl-4" *ngIf="excluirTodos">Si</span>
                  <span class="pl-4" *ngIf="!excluirTodos">No</span>
              </td>
          </div>
      </div>
  </div>
  
  <!-- TABLA -->
  
  <div style="margin-top: 20px;">
      <table *ngIf="!tableRender" [dtOptions]="dtOptions" datatable class="table table-striped tabla display nowrap" aria-describedby="tabla configuracion exclusiva">
          <thead class="header_tabla">
              <tr>
                  <th>Sede</th>
                  <th>Asignatura</th>
                  <th>ID Sección</th>
                  <th>Sección</th>
                  <th>Tipo asignatura</th>
                  <th>Usuario</th>
                  <th>Fecha modificación</th>
                  <th>Excluir</th>
              </tr>
          </thead>
          <tbody>
          </tbody>
      </table>
      <table [dtOptions]="dtOptions" datatable class="table table-striped tabla display nowrap" *ngIf="tableRender" aria-describedby="tabla configuracion exclusiva">
          <thead class="header_tabla">
              <tr>
                  <th>Sede</th>
                  <th>Asignatura</th>
                  <th>ID Sección</th>
                  <th>Sección</th>
                  <th>Tipo asignatura</th>
                  <th>Usuario</th>
                  <th>Fecha modificación</th>
                  <th>Excluir</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let dato of listaDatos">
                  <td>{{dato.sede}}</td>
                  <td>{{dato.descAsignatura}}</td>
                  <td>{{dato.idSeccion}}</td>
                  <td>{{dato.codigoSeccion}}</td>
                  <td>{{dato.tipoAsignatura}}</td>
                  <td>{{dato.usuario}}</td>
                  <td>{{dato.fecha}}</td>
                  <td>
                      <label class="switch">
                      <input type="checkbox" [checked]="dato.excluir" (click)="modificacionDato(dato)" [(ngModel)]="dato.excluir">
                          <span class="slider round"></span>
                      </label>
                      <span class="pl-4" *ngIf="dato.excluir">Si</span>
                      <span class="pl-4" *ngIf="!dato.excluir">No</span>
                  </td>
              </tr>
          </tbody>
      </table>
      <div class="d-flex justify-content-center pb-5" *ngIf="listaDatos.length > 0">
          <button type="button" class="boton-secundario" data-toggle="tooltip" data-placement="top"
              title="DESCARGAR" alt="DESCARGAR" (click)="descargarDatos()">
              DESCARGAR
          </button>
          <button (click)="guardar()" class="btn boton-primario ml-5" data-toggle="tooltip" data-placement="top" title="GUARDAR"
              alt="GUARDAR" style="z-index: 1;">
              GUARDAR
          </button>
      </div>
  </div>
  <!-- FIN TABLA -->
</div>

<div class="contenedor-exclusion-masivo" [hidden]="currentTab !== 'masivo'">
  <div class="d-flex justify-content-center pb-5 mt-5">
    <button (click)="modalConfirmarExclusionMasiva(false)" type="button" class="boton-secundario" data-toggle="tooltip" data-placement="top" title="INCLUIR" alt="INCLUIR">
      Incluir
    </button>
    <button (click)="modalConfirmarExclusionMasiva(true)" class="btn boton-primario ml-5" data-toggle="tooltip" data-placement="top" title="EXCLUIR" alt="EXCLUIR" style="z-index: 1;">
      Excluir
    </button>
  </div>
</div>

<!-- MODAL CONFIRMAR-->
<div class="modal fade" id="modalConfirmar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
          <div class="row align-items-center my-3 mx-4">
            <p class="mb-4 ml-3">{{tituloModal}}</p>
            <span class="mb-0 ml-3">{{textoModal}}</span>
          </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" (click)="exclusionMasiva(!excluirTodos)" data-dismiss="modal">
          Si
        </button>
        <button type="button" class="btn boton-primario my-2" data-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL CONFIRMAR-->

<!-- Modal exclusion masiva -->
<button id="btn-trigger-modal-exclusion-masiva" class="btn d-none" data-toggle="modal" data-target="#modalExclusionMasiva">Modal exclusion</button>
<div class="modal fade" id="modalExclusionMasiva" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
          <div class="row align-items-center my-3 mx-4">
            <p class="mb-4 ml-3">¿Estás seguro/a que deseas {{ excluir ? 'excluir' : 'incluir' }} por los filtros seleccionados?</p>
            <span class="mb-0 ml-3">Al presionar el botón SI, todas las asignaturas quedarán {{ excluir ? 'excluidas' : 'incluidas' }} y se modificarán automaticamente.</span>
          </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" (click)="exclusionAsignaturas(excluir)" data-dismiss="modal">
          Si
        </button>
        <button type="button" class="btn boton-primario my-2" data-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Fin Modal exclusion masiva -->